<template>
  <div class="app-container">
    <!--    <div class="filter-container">
      <label> 站点：</label>
      <el-select
        v-model="queryStationId"
        :placeholder="$t('company.station')"
        style="width: 200px"
        class="filter-item"
      >
        <el-option label="全部站点" value=""/>
        <el-option
          v-for="(item,index) in stationList"
          :key="index"
          :label="item.stationName"
          :value="item.stationId"
        />
      </el-select>
      <el-button
        v-waves
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        style="margin-left: 20px"
        @click="getList"
      >{{ $t('table.search') }}</el-button>
    </div>-->
    <el-row type="flex" justify="space-between">
      <el-col :span="12">&nbsp;</el-col>
      <el-col :span="12">
        <el-button
          :disabled="buttonDisable"
          type="info"
          icon="el-icon-setting"
          @click="handleSetProd"
        >配置油品</el-button>
        <el-button
          :disabled="buttonDisable"
          type="primary"
          icon="el-icon-edit-outline"
          @click="handleSetDifPrice"
        >修改价格</el-button>
        <el-button
          :disabled="buttonDisable"
          type="success"
          icon="el-icon-success"
          @click="handleModifyStatus(1)"
        >启用油枪</el-button>
        <el-button
          :disabled="buttonDisable"
          type="danger"
          icon="el-icon-error"
          @click="handleModifyStatus(-1)"
        >禁用油枪</el-button>
        <el-button type="warning" icon="el-icon-menu" @click="handleAllSelCl">全选/取消</el-button>
      </el-col>
    </el-row>
    <el-table
      v-loading="listLoading"
      ref="multipleTable"
      :data="fpList"
      border
      fit
      highlight-current-row
      style="width: 100%;"
      @row-click="handleRowClick"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" label="选择" width="55" />
      <el-table-column label="枪号" align="center" width="80px">
        <template slot-scope="scope">
          <span>{{ scope.row.fpNo }}</span>
        </template>
      </el-table-column>
      <el-table-column label="站点名称" align="center" width="150px">
        <template slot-scope="scope">
          <span>{{ scope.row.stationName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="油品" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.prodName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="单价" align="center" width="90px">
        <template slot-scope="scope">
          <span>{{ scope.row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column label="固件版本" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.version }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.status | fpStatusFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="设备号" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.imei }}</span>
        </template>
      </el-table-column>
      <el-table-column label="扫码加油码" align="center">
        <template slot-scope="scope">
          <span style="color: #009bf0;cursor: pointer" @click="checkQRCode(scope.row)">查看二维码</span>
        </template>
      </el-table-column>
      <el-table-column label="是否在线" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.isOnline | statusFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="更新时间" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.updatedTime }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :visible.sync="dialogProd" :close-on-click-modal="false" title="配置油品" width="30%">
      <el-row type="flex" justify="space-around">
        <el-col :span="4" />
        <el-col :span="16">
          <el-form ref="prodForm" :rules="prodFormRules" :model="prodFormData">
            <el-form-item label="选择油品" prop="prodId">
              <el-select v-model="prodFormData.prodId" placeholder="请选择油品">
                <el-option
                  v-for="item in prodList"
                  :key="item.prodId"
                  :label="item.prodStandard + '-' + item.prodName"
                  :value="item.prodId"
                />
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="4" />
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogProd = false">{{ $t('table.cancel') }}</el-button>
        <el-button type="primary" @click="setFpProd">{{ $t('table.confirm') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogPriceChoose"
      :close-on-click-modal="false"
      title="配置油价"
      width="30%"
    >
      <el-row>
        <el-col :offset="4">
          <el-button type="primary" icon="el-icon-remove" @click="handleSetSamePrice">配置统一油价</el-button>
          <label class="tips">&nbsp;&nbsp;&nbsp;&nbsp;*选择的油枪配置统一的价格</label>
        </el-col>
      </el-row>
      <br >
      <el-row>
        <el-col :offset="4">
          <el-button type="success" icon="el-icon-circle-plus" @click="handleSetDifPrice">配置多个油价</el-button>
          <label class="tips">&nbsp;&nbsp;&nbsp;&nbsp;*选择的油枪，每个都配置一个单独的价格</label>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogPriceChoose = false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogPriceSame"
      :close-on-click-modal="false"
      title="统一油价配置"
      width="30%"
    >
      <el-form ref="samePriceForm" :model="samePriceData" :rules="samePriceFormRules">
        <el-form-item label="请输入油价：" prop="samePrice">
          <el-input v-model="samePriceData.samePrice" placeholder="油品价格" style="width: 50%" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogPriceSame = false">{{ $t('table.cancel') }}</el-button>
        <el-button type="primary" @click="setSamePrice">{{ $t('table.confirm') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-if="dialogPriceDif"
      :visible.sync="dialogPriceDif"
      :close-on-click-modal="false"
      title="多个油价配置"
      width="50%"
    >
      <el-row type="flex" class="row-bg" justify="space-around">
        <!--<el-col :span="formSpan">-->
        <el-col span="24">
          <el-form
            ref="difPriceForm"
            :model="difPriceData"
            :rules="difPriceFormRules"
            style="width: 100%"
          >
            <template v-if="multipleSelection.length === 1">
              <el-input
                :ref="multipleSelection[0].fpId + 'ref'"
                v-model.number="difPriceData.fpConfigs[0].price"
                :key="multipleSelection[0].fpId"
                :class="errorFlagList[0] ? 'error' : ''"
                width="30%"
                placeholder="价格"
              >
                <template slot="prepend">
                  <span
                    class="priceStation"
                  >{{ multipleSelection[0].stationName + '#' + multipleSelection[0].fpNo }}</span>
                </template>
              </el-input>
            </template>
            <template v-else>
              <template v-for="(item,index) in multipleSelection">
                <!--<label v-if="errorFlagList[index]" :key="item.fpId + 'label'" class="error">输入价格有误！</label>-->
                <el-input
                  :ref="item.fpId + 'ref'"
                  v-model.number="difPriceData.fpConfigs[index].price"
                  :key="item.fpId"
                  :class="errorFlagList[index] ? 'error' : ''"
                  :style="formStyle"
                  :width="formWidth"
                  placeholder="价格"
                >
                  <template slot="prepend">
                    <span class="priceStation">{{ item.stationName + '#' + item.fpNo }}</span>
                  </template>
                </el-input>&nbsp;&nbsp;
              </template>
            </template>
          </el-form>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-around">
        <el-col :span="10">&nbsp;</el-col>
        <el-col :span="5">
          <span v-if="mainInfo" class="error">* 红色输入框的价格有误！</span>
        </el-col>
        <el-col :span="9">&nbsp;</el-col>
      </el-row>
      <el-row>
        <el-col>&nbsp;</el-col>
      </el-row>

      <el-row type="flex" justify="space-around">
        <!--<el-col :span="5">
          &nbsp;
        </el-col>-->
        <el-col :span="24">
          <div style="text-align: center">
            <el-button @click="dialogPriceDif = false">{{ $t('table.cancel') }}</el-button>
            <el-button type="primary" @click="setDifPrice">{{ $t('table.confirm') }}</el-button>
          </div>
        </el-col>
        <!-- <el-col :span="5">
          &nbsp;
        </el-col>-->
      </el-row>
    </el-dialog>
    <!--自助加油二维码-->
    <el-dialog :visible.sync="selfFuellingVisible" title="扫码加油二维码" width="30%">
      <div style="width: 100%;text-align: center">
        <img :src="getQRCodeUrl" style="width: 80%" alt >
      </div>
      <span slot="footer" class="dialog-footer" style="display: block;text-align: center">
        <el-button type="primary" plain @click="downQRCode">下载二维码</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { getToken } from '@/utils/auth'
import { listStationOfType } from '@/api/station'
import waves from '@/directive/waves' // 水波纹指令
import {
  list4gFp,
  modifyStatusBatch,
  setProdBatch,
  setSamePriceBatch
} from '@/api/fpConfig'
import { listProd } from '@/api/product'
import { getEmpInfo, getUserPermissions } from '@/utils/auth'
const G4_URL = 'g4.jtleguanyou.com'
// const G4_URL = 'g4.test.jtleguanyou.com';
const setPriceUrl = 'station.jtleguanyou.com'
// const setPriceUrl = 'station.test.jtleguanyou.com';
// const PRICE_API = '/api/price-set'
const PRICE_API = '/api/station/setPriceBatch'
const COMMAND_API = '/api/send-command'
const UNLINE_BATCH_API = '/api/is-online-batch'
const statusArr = [
  { name: '全部', value: '' },
  { name: '锁定', value: '-1' },
  { name: '正常', value: '1' }
]
const COMMAND = {
  lock: 'Lock',
  unLock: 'UnLock',
  updateProd: 'DownloadArchive',
  updatePrice: 'DownloadPrice',
  updateVersion: 'DownloadVer'
}
export default {
  name: 'List',
  directives: {
    waves
  },
  filters: {
    typeFilter (type) {},
    fpStatusFilter (status) {
      if (status === 1) {
        return '正常'
      } else if (status === -1) {
        return '锁定'
      } else {
        return '-'
      }
    },
    statusFilter (status) {
      if (typeof status === 'undefined') {
        return '获取状态失败'
      }
      if (status) {
        return '在线'
      } else {
        return '离线'
      }
    }
  },
  data () {
    const checkPrice = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error('请输入正确的油品价格！'))
        return
      }
      // const reg = /^[0-9]+([.]{1}[0-9]+){0,1}$/
      const reg = /^\d+(\.\d{0,2})?$/
      if (reg.test(value)) {
        callback()
      } else {
        callback(new Error('请输入正确的油品价格！'))
      }
    }
    return {
      formWidth: null,
      formSpan: 20,
      // formStyle: 'width: 24%',
      formStyle: 'min-width: 24%',
      prodList: [],
      listLoading: true,
      queryStationId: '',
      statusArr,
      stationList: [],
      fpList: [],
      priceList: [],
      multipleSelection: [],
      errorFlagList: [],
      dialogPriceChoose: false,
      dialogProd: false,
      dialogPriceSame: false,
      dialogPriceDif: false,
      buttonDisable: true,
      mainInfo: false,
      samePriceData: {
        samePrice: 0
      },
      difPriceData: {
        fpConfigs: []
      },
      prodFormData: {
        prodId: '',
        fpIds: []
      },
      priceFormData: {
        fpIds: []
      },
      prodFormRules: {
        prodId: [{ required: true, message: '请选择油品', trigger: 'change' }]
      },
      samePriceFormRules: {
        samePrice: [
          { required: true, message: '请选择正确的油价', trigger: 'blur' },
          {
            message: '油品价格不正确！',
            trigger: 'blur',
            validator: checkPrice
          }
        ]
      },
      difPriceFormRules: {},
      // 自助加油
      selfFuellingVisible: false,
      getQRCodeUrl: '' // 二维码请求地址
    }
  },
  created () {
    listStationOfType({ type: '2' }).then(resp => {
      this.stationList = resp.data.data
    })
    listProd({}).then(resp => {
      this.prodList = resp.data.data
    })
    this.getList()
  },
  methods: {
    getList () {
      this.fpList = []
      list4gFp({ stationId: this.queryStationId }).then(resp => {
        // this.fpList = resp.data.data
        const list = resp.data.data.items
        if (list && list.length) {
          const fps = []
          for (let i = 0; i < list.length; i++) {
            fps[i] = {
              stationId: list[i].stationId,
              fpId: list[i].fpId,
              fpNo: list[i].fpNo
            }
          }
          // 监测油枪是否在线
          const protocol = document.location.protocol
          const preUrl = protocol + '//' + G4_URL
          axios({
            method: 'post',
            url: preUrl + UNLINE_BATCH_API,
            timeout: 5000,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              token: getToken()
            },
            data: { groupId: getEmpInfo().groupId, param: JSON.stringify(fps) },
            transformRequest: [
              function (data) {
                // 将数据转换为表单数据
                let ret = ''
                for (const it in data) {
                  ret +=
                    encodeURIComponent(it) +
                    '=' +
                    encodeURIComponent(data[it]) +
                    '&'
                }
                return ret
              }
            ]
          })
            .then(res => {
              const fpStatus = res.data.data
              for (let j = 0; j < fpStatus.length; j++) {
                for (let i = 0; i < list.length; i++) {
                  if (list[i].fpId === fpStatus[j].fpId) {
                    list[i]['isOnline'] = fpStatus[j].isOnline
                    break
                  }
                }
              }
              this.fpList = list
              this.listLoading = false
            })
            .then(() => {
              // this.handleAllSelCl()//是否全选
            })
            .catch(e => {
              console.log(e)
              this.fpList = list
              this.handleAllSelCl()
              this.listLoading = false
            })
        }
        this.listLoading = false
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      if (this.multipleSelection.length === 0) {
        this.buttonDisable = true
      } else {
        this.buttonDisable = false
      }
    },
    handleRowClick (row) {
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    handleAllSelCl () {
      if (this.multipleSelection.length === 0) {
        for (let i = 0; i < this.fpList.length; i++) {
          this.$refs.multipleTable.toggleRowSelection(this.fpList[i], true)
        }
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSetProd () {
      if (!getUserPermissions('STATION_FP_SETTING')) {
        this.$notify({
          title: '错误',
          message: '抱歉，你没有权限，请联系管理员开通',
          type: 'error'
        })
        return
      }
      this.prodFormData['prodId'] = ''
      this.prodFormData['fpIds'] = []
      this.dialogProd = true
      this.$nextTick(() => {
        this.$refs['prodForm'].clearValidate()
      })
    },
    setFpProd () {
      this.$refs['prodForm'].validate(valid => {
        if (valid) {
          const selected = this.multipleSelection
          for (let i = 0; i < selected.length; i++) {
            this.prodFormData['fpIds'][i] = selected[i].fpId
          }
          const postData = {
            prodId: this.prodFormData.prodId,
            fpIds: this.prodFormData.fpIds
          }
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          setProdBatch(postData)
            .then(resp => {
              const empInfo = getEmpInfo()
              if (empInfo && empInfo.groupId) {
                // 发送修改油品指令
                this.sendCommand(
                  empInfo.groupId,
                  COMMAND.updateProd,
                  this.multipleSelection
                )
              }
              this.dialogProd = false
            })
            .then(() => {
              loading.close()
              this.getList()
            })
            .catch(e => {
              loading.close()
              this.dialogProd = false
              this.$notify.error({
                title: '失败',
                message: '失败原因:' + e
              })
            })
        }
      })
    },
    handleSetPrice () {
      this.dialogPriceChoose = true
    },
    handleModifyStatus (type) {
      if (!getUserPermissions('STATION_FP_SETTING')) {
        this.$notify({
          title: '错误',
          message: '抱歉，你没有权限，请联系管理员开通',
          type: 'error'
        })
        return
      }
      let opt = ''
      if (type === -1) {
        opt = '禁用'
      } else if (type === 1) {
        opt = '启用'
      } else {
        alert('没有该状态！')
        return
      }
      const selected = this.multipleSelection
      this.$confirm('确定' + opt + '这' + selected.length + '油枪吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        const selected = this.multipleSelection
        const fpIds = []
        for (let i = 0; i < selected.length; i++) {
          fpIds.push(selected[i].fpId)
        }
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        modifyStatusBatch({ status: type, fpIds: fpIds })
          .then(resp => {
            const empinfo = getEmpInfo()
            if (empinfo && empinfo.groupId) {
              let mand = ''
              if (type === -1) {
                mand = COMMAND.lock
              } else if (type === 1) {
                mand = COMMAND.unLock
              }
              this.sendCommand(
                empinfo.groupId,
                mand,
                this.multipleSelection
              ).then(() => {
                loading.close()
              })
            }
            this.getList()
          })
          .catch(e => {
            loading.close()
            this.$notify.error({
              title: '失败',
              message: '失败原因:' + e
            })
          })
      })
    },
    handleSetSamePrice () {
      this.samePriceData.samePrice = 0
      this.dialogPriceSame = true
      this.$nextTick(() => {
        this.$refs['samePriceForm'].clearValidate()
      })
    },
    setSamePrice () {
      this.$refs['samePriceForm'].validate(valid => {
        if (valid) {
          const selected = this.multipleSelection
          const postData = {
            price: 0,
            fpIds: []
          }
          postData.price = this.samePriceData.samePrice
          for (let i = 0; i < selected.length; i++) {
            postData.fpIds[i] = selected[i].fpId
          }
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          setSamePriceBatch(postData)
            .then(resp => {
              this.getList()
              this.dialogPriceSame = false
              this.dialogPriceChoose = false
              this.$notify({
                title: '成功',
                message: resp.data.data + '条油枪的油价已被更新！',
                type: 'success'
              })
              loading.close()
            })
            .catch(() => {
              loading.close()
            })
        }
      })
    },
    handleSetDifPrice () {
      if (!getUserPermissions('STATION_FP_SETTING')) {
        this.$notify({
          title: '错误',
          message: '抱歉，你没有权限，请联系管理员开通',
          type: 'error'
        })
        return
      }
      this.formSpan = 20
      this.formWidth = null
      if (this.multipleSelection.length < 4) {
        this.formSpan = this.multipleSelection.length * 5
        this.formStyle = 'min-width:30%'
        if (this.multipleSelection === 2) {
          this.formWidth = '40%'
        }
      }
      this.mainInfo = false
      this.errorFlagList = []
      this.difPriceData = {}
      this.difPriceData['fpConfigs'] = []
      const selected = this.multipleSelection
      for (let i = 0; i < selected.length; i++) {
        this.difPriceData['fpConfigs'][i] = {
          fpId: selected[i].fpId,
          price: 0,
          fpNo: selected[i].fpNo,
          stationId: selected[i].stationId
        }
        this.errorFlagList.push(false)
      }
      this.dialogPriceDif = true
      this.$nextTick(() => {
        this.$refs['difPriceForm'].clearValidate()
      })
    },
    setDifPrice () {
      const checkAllPrice1 = this.checkAllPrice()
      this.mainInfo = !checkAllPrice1
      if (!checkAllPrice1) {
        return
      }
      const emp = getEmpInfo()
      let groupId = ''
      if (emp && emp.groupId) {
        groupId = emp.groupId
      } else {
        alert('获取不到当前登录信息，请重新登录后再试！')
        return
      }
      const postData = {
        groupId: groupId,
        param: JSON.stringify(this.difPriceData.fpConfigs)
      }
      const protocol = document.location.protocol
      const priceUrl = protocol + '//' + setPriceUrl
      // const priceUrl = protocol + '//' + TEST_G4_URL
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      axios({
        method: 'post',
        url: priceUrl + PRICE_API,
        timeout: 5000,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          token: getToken()
        },
        data: postData,
        transformRequest: [
          function (data) {
            // 将数据转换为表单数据
            let ret = ''
            for (const it in data) {
              ret +=
                encodeURIComponent(it) +
                '=' +
                encodeURIComponent(data[it]) +
                '&'
            }
            return ret
          }
        ]
      })
        .then(resp => {
          console.log(resp)
          if (resp.data.code == 0) {
            this.$notify({
              title: '成功',
              message: '发送指令成功！',
              type: 'success'
            })
          } else {
            this.$notify.error({
              title: '失败',
              message: '油价更新失败.原因：' + resp.data.msg
            })
          }
          /* const data = resp.data.data
        if (JSON.stringify(data) === '{}') {
          this.sendCommand(emp.groupId, COMMAND.updatePrice, this.multipleSelection)
        } else {
          this.$notify({
            title: '部分成功',
            message: '结果：' + JSON.stringify(resp.data.data),
            type: 'waring'
          })
          this.sendCommand(emp.groupId, COMMAND.updatePrice, this.multipleSelection)
        }*/
          this.getList()
          this.dialogPriceDif = false
          loading.close()
        })
        .catch(e => {
          this.$notify.error({
            title: '失败',
            message: '油价更新失败.原因：' + e
          })
          loading.close()
        })
    },
    checkAllPrice () {
      let pass = true
      const fpList = this.difPriceData.fpConfigs
      const reg = /^\d+(\.\d{0,2})?$/
      for (let i = 0; i < fpList.length; i++) {
        if (reg.test(fpList[i].price)) {
          const num = Number.parseFloat(fpList[i].price)
          if (num <= 0) {
            pass = false
            this.errorFlagList.splice(i, 1, true)
          } else {
            fpList[i].price = Number.parseFloat(fpList[i].price)
            this.errorFlagList.splice(i, 1, false)
          }
        } else {
          pass = false
          this.errorFlagList.splice(i, 1, true)
        }
      }
      return pass
    },
    getCommandParam () {
      return {
        groupId: '',
        command: '',
        param: ''
      }
    },
    sendCommand (groupId, command, fps) {
      const protocol = document.location.protocol
      const prefixUrl = protocol + '//' + G4_URL
      const commandUrl = prefixUrl + COMMAND_API
      const params = this.getCommandParam()
      params['groupId'] = groupId
      params['command'] = command
      const arrFp = []
      for (let i = 0; i < fps.length; i++) {
        arrFp[i] = {
          stationId: fps[i].stationId,
          fpId: fps[i].fpId,
          fpNo: fps[i].fpNo,
          price: fps[i].price
        }
        if (command === 'Lock') {
          arrFp[i].status = -1
        } else if (command === 'UnLock') {
          arrFp[i].status = 1
        }
      }
      params['param'] = JSON.stringify(arrFp)
      console.log('params:', params)
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: commandUrl,
          timeout: 5000,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: getToken()
          },
          data: params,
          transformRequest: [
            function (data) {
              // 将数据转换为表单数据
              let ret = ''
              for (const it in data) {
                ret +=
                  encodeURIComponent(it) +
                  '=' +
                  encodeURIComponent(data[it]) +
                  '&'
              }
              return ret
            }
          ]
        })
          .then(res => {
            console.log('updateProd', res.data)
            this.$notify({
              title: '成功',
              message: '发送指令成功！',
              type: 'success'
            })
            resolve(res.data)
          })
          .catch(e => {
            this.$notify({
              title: '失败',
              message: '发送指令失败！原因：' + e,
              type: 'error'
            })
            reject(e)
          })
      })
    },
    // 查看二维码
    checkQRCode (val) {
      console.log(val)
      this.getQRCodeUrl =
        'http://' + setPriceUrl + '/api/fp/fpQRCode?fpId=' + val.fpId
      this.selfFuellingVisible = true
    },
    // 下载二维码
    downQRCode () {
      const alink = document.createElement('a')
      alink.href = this.getQRCodeUrl
      // alink.download = "QRCode.png"; //图片名
      alink.click()
    }
  }
}
</script>
<style scoped>
.tips {
  color: gray;
}
.error {
  color: #ff4d51;
  border: 1px solid #ff4d51;
  background-color: transparent;
}
.normal {
  border: black;
}
.middle {
  width: 100px;
}
.priceStation {
  display: inline-block;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
